// extracted by mini-css-extract-plugin
export default {"tagInput":"TagInput_tagInput__0WVNd","tag":"TagInput_tag__Kgg8I"};